import s from './FilesUploader.scss'
import { Files } from './Files'
import Dropzone from 'react-dropzone'
import cn from 'classnames'

const FilesUploader = ({
  filesClassName = '',
  className = '',
  files,
  removeFile,
  onDrop,
  withLinks,
  entityIndex,
  entity
}) => {
  return (
    <>
      {files.length > 0 && (
        <Files
          filesClassName={filesClassName}
          withLinks={withLinks}
          removeFile={removeFile}
          files={files}
          entity={entity}
          entityIndex={entityIndex}
        />
      )}
      <div className={s.clearfix} />
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps }) => (
          <section>
            <div
              {...getRootProps({
                className: cn(s.dropzone, {
                  [className]: className
                })
              })}
            >
              <input {...getInputProps()} />
              <p>Drag and drop some files here, or click to select files</p>
            </div>
          </section>
        )}
      </Dropzone>
    </>
  )
}

export default FilesUploader
